module.exports = __webpack_public_path__ + "resources/img/equipment_tab4_img2_m.5cbb60781fcb010d2eb30a06286af3bb.jpg";